export default "__VITE_ASSET__3cf97e28__"